import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { Labels } from '@core/constants/labels';
import { ExamNonReadCounts } from '@core/models/exam-non-read-counts.model';
import { ExamRequest } from '@core/models/exam-request.model';
import { ExamService } from '@core/services/exam-service/exam-service.service';
import { WebsocketService } from '@core/services/websocket-service/websocket-service.service';
import { Subscription } from 'rxjs';
import { ExamCardComponent } from '../exam-card/exam-card.component';
@Component({
  selector: 'app-opened-discussions',
  standalone: true,
  imports: [
    ExamCardComponent,
    MatPaginatorModule,
    CommonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './opened-discussions.component.html',
  styleUrl: './opened-discussions.component.scss',
})
export class OpenedDiscussionsComponent implements OnInit, OnDestroy {
  openedDiscussions: ExamNonReadCounts[] = [];

  subscriptions = new Subscription();

  labels = Labels.EXAM_LIST;

  loading = true;

  pageEvent: PageEvent = {
    pageIndex: 0,
    pageSize: 10,
    length: 0,
    previousPageIndex: 0,
  };

  count = 0;
  pageSize = 10;
  pageIndex = 0;
  hidePageSize = true;
  showFirstLastButtons = true;

  websocketListeners: any[] = [];

  constructor(
    private examService: ExamService,
    private router: Router,
    private websocketService: WebsocketService,
  ) {}

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;
    const currentFilterData = this.examService.filterData;
    currentFilterData.page_size = this.pageSize;
    currentFilterData.page = this.pageIndex;
    this.examService.updateFilters(currentFilterData);
    this.updateList();
  }

  handleExamSelected(exam: ExamRequest): void {
    this.examService.setCurrentExam(exam);
    const url = `dashboard/${exam.id}`;
    this.router.navigate([url]);
  }

  updateList() {
    this.loading = true;
    const sub = this.examService.getOpenedDiscussions().subscribe((res) => {
      this.openedDiscussions = res.results;
      this.count = res.count;
      this.loading = false;
    });
    this.subscriptions.add(sub);
  }

  ngOnInit() {
    this.updateList();

    const w1 = this.websocketService.listen('NEW_MESSAGE', (data) => {
      this.updateList();
    });
    this.websocketListeners.push(w1);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.websocketListeners.forEach((wl) =>
      this.websocketService.stopListening(wl),
    );
  }
}
